import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

/**
 * Consistent section header used across pages.
 * Renders an eyebrow pill, a heading, and an optional supporting paragraph.
 */
export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  as: Heading = 'h2',
  className = '',
}) {
  const isCenter = align === 'center';

  return (
    <motion.div
      className={`${isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl text-left'} ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.4 }}
      variants={fadeUp}
    >
      {eyebrow && (
        <span className={`eyebrow-pill ${isCenter ? 'mx-auto' : ''}`}>
          <span className="h-1.5 w-1.5 rounded-full bg-primary" />
          {eyebrow}
        </span>
      )}
      <Heading className="mt-5 font-display text-3xl font-semibold tracking-tight text-text sm:text-4xl">
        {title}
      </Heading>
      {description && (
        <p className={`mt-4 text-base leading-relaxed text-textLight ${isCenter ? 'mx-auto max-w-2xl' : ''}`}>
          {description}
        </p>
      )}
    </motion.div>
  );
}
